"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _components = require("components");

var _translationNode = require("egov-ui-kit/utils/translationNode");

var _translationNode2 = _interopRequireDefault(_translationNode);

var _commons = require("egov-ui-kit/utils/commons");

var _isEmpty = require("lodash/isEmpty");

var _isEmpty2 = _interopRequireDefault(_isEmpty);

require("./index.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var imageStyles = {
  maxHeight: "100px",
  minHeight: "100px"
};

var callIconStyle = {
  marginLeft: "17px",
  height: "17px",
  width: "17px",
  borderRadius: "50%",
  position: "relative",
  top: "2px"
};

var bottomInfoTemplate = function bottomInfoTemplate(item, role) {
  return role !== "citizen" ? _react2.default.createElement(
    "div",
    null,
    _react2.default.createElement(
      "div",
      { className: "employee-bottom-info-cont" },
      (role === "ao" || role === "csr") && _react2.default.createElement(
        "div",
        { className: "submitted-by-text" },
        item.complaintStatus != "UNASSIGNED" && item.complaintStatus != "CLOSED" && _react2.default.createElement(
          "div",
          { className: "clearfix" },
          _react2.default.createElement(
            "div",
            { className: "inline-Localization-text" },
            _react2.default.createElement(_translationNode2.default, { containerStyle: { display: "inline-block" }, fontSize: 12, label: "Assigned to:" }),
            _react2.default.createElement(_translationNode2.default, {
              containerStyle: { display: "inline-block" },
              fontSize: 12,
              color: "#464646",
              labelStyle: { marginLeft: "3px" },
              label: item.assignedTo
            })
          )
        ),
        item && item.source && item.source && _react2.default.createElement(
          "div",
          { className: "clearfix" },
          _react2.default.createElement(
            "div",
            { className: "inline-Localization-text" },
            _react2.default.createElement(_translationNode2.default, { containerStyle: { display: "inline-block" }, fontSize: 12, label: "Source:" }),
            _react2.default.createElement(_translationNode2.default, {
              containerStyle: { display: "inline-block" },
              fontSize: 12,
              color: "#464646",
              labelStyle: { marginLeft: "3px" },
              label: item && item.source && item.source == "web" ? "Web" : item && item.source && item.source == "whatsapp" ? "WhatsApp" : item && item.source && item.source == "talktomayor" ? "Talk To Mayor" : item && item.source && item.source == "lettertomayor" ? "Letter To Mayor" : item && item.source && item.source == "voicecallreceipt" ? "Voice Call Receipt" : item && item.source && item.source == "whatsapptomayor" ? "Whatsapp to Mayor" : item && item.source && item.source == "cmogrievance" ? "CMO Grievance" : item && item.source && item.source == "voicecallkmccentre" ? "KMC Call Centre (Voice Call)" : item && item.source && item.source == "voicecallcontrolroom" ? "KMC Control Room (Voice Call)" : item && item.source && item.source == "voicecallkmccentreoutreach" ? "Call Centre - OutReach (Voice Call)" : ""
            })
          )
        )
      )
    ),
    item.escalatedTo && role !== "csr" && _react2.default.createElement(
      "div",
      { className: "submitted-by-text" },
      "Escalated To: ",
      _react2.default.createElement(
        "span",
        { style: { color: "#464646" } },
        item.escalatedTo
      )
    )
  ) : null;
};

var getStatusAndChangeColor = function getStatusAndChangeColor(status, assignee) {
  var statusObj = {
    style: {},
    message: "",
    containerStyle: {}
  };
  switch (status) {
    case "CS_COMMON_OPEN_UCASE":
      statusObj.style = {
        // color: "#f89a3f",
        color: "#ffffff"
      };
      statusObj.message = _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(_translationNode2.default, { label: "CS_COMMON_COMPLAINT" }),
        _react2.default.createElement(_translationNode2.default, { className: "complaint-status-reassigned", label: "CS_COMMON_RE_ASSIGNED" }),
        _react2.default.createElement(_translationNode2.default, { label: "CS_MYCOMPLAINTS_TO" }),
        _react2.default.createElement(_translationNode2.default, { className: "complaint-assignee", label: "" + assignee })
      );
      statusObj.containerStyle = {
        backgroundColor: "red"
      };
      break;
    case "CS_COMMON_CLOSED_UCASE":
      statusObj.style = {
        // color: "#5385a6",
        color: "#ffffff"
      };
      statusObj.message = _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(_translationNode2.default, { label: "CS_COMMON_COMPLAINT" }),
        _react2.default.createElement(_translationNode2.default, { className: "complaint-status-resolved", label: "CS_COMMON_RESOLVED" }),
        _react2.default.createElement(_translationNode2.default, { label: "CS_MYCOMPLAINTS_RATE" })
      );
      statusObj.containerStyle = {
        backgroundColor: "#4CAF50"
      };
      break;
    case "CS_COMMON_REJECTED_UCASE":
      statusObj.style = {
        // color: "#e74c3c",
        color: "#ffffff"
      };
      statusObj.message = _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(_translationNode2.default, { label: "CS_MYCOMPLAINTS_COMPLAINT_PREFIX" }),
        _react2.default.createElement(_translationNode2.default, { className: "complaint-status-rejected", label: "CS_COMMON_REJECTED" }),
        _react2.default.createElement(_translationNode2.default, { label: "CS_MYCOMPLAINTS_RATE" })
      );
      statusObj.containerStyle = {
        backgroundColor: "red"
      };
      break;
    default:
      statusObj.style = {
        // color: "#484848",
        color: "#ffffff"
      };
      statusObj.message = "CS_MYCOMPLAINTS_RE_ASSIGNED " + assignee;
      statusObj.containerStyle = {
        backgroundColor: "#4CAF50"
      };
  }
  if (status && status.toLowerCase().includes("overdue")) {
    statusObj.style = { color: "#e74c3c" };
    statusObj.message = "";
  }
  if (status && status.toLowerCase().includes("left")) {
    statusObj.style = { color: "#22b25f" };
    statusObj.message = "";
  }
  if (status && status.includes("/")) {
    if (["0", "1", "2", "3"].indexOf(status.split("/")[0]) > -1) {
      statusObj.style = { color: "#e74c3c" };
      statusObj.message = "";
    } else {
      statusObj.style = { color: "#22b25f" };
      statusObj.message = "";
    }
  }
  return statusObj;
};

var Complaints = function Complaints(_ref) {
  var complaints = _ref.complaints,
      complaintLocation = _ref.complaintLocation,
      role = _ref.role,
      onComplaintClick = _ref.onComplaintClick,
      noComplaintMessage = _ref.noComplaintMessage,
      heightOffset = _ref.heightOffset;

  return complaints.length === 0 ? _react2.default.createElement(
    "div",
    { className: "no-complaints-message-cont", style: heightOffset && { height: "calc(110vh - " + heightOffset + ")" } },
    _react2.default.createElement(_translationNode2.default, { label: noComplaintMessage, dark: true, fontSize: "16px", labelStyle: { letterSpacing: "0.7px" } })
  ) : complaints.map(function (complaint, complaintIndex) {
    console.log({ complaint: complaint });

    var _ref2 = complaint.addressDetail || "",
        premise = _ref2.premise,
        streetName = _ref2.streetName,
        ward = _ref2.ward,
        pincode = _ref2.pincode;

    var complaintHeader = complaint.category && complaint.category;
    //   const complaintHeader = complaint.header && "SERVICEDEFS." + complaint.header.toUpperCase();
    return _react2.default.createElement(
      "div",
      { id: "complaint-" + complaintIndex, className: "complaints-card-main-cont", key: "complaint-" + complaintIndex },
      _react2.default.createElement(_components.Card, {
        onClick: function onClick(e) {
          onComplaintClick(encodeURIComponent(complaint.complaintNo));
        },
        className: "complaint-card",
        textChildren: _react2.default.createElement(
          "div",
          { className: "compla.int-card-wrapper" },
          _react2.default.createElement(
            "div",
            { className: "complaint-header-cont" },
            _react2.default.createElement(_translationNode2.default, {
              className: "complaint-header text-bold dark-color",
              fontSize: "16px",
              dark: true,
              bold: true,
              label: complaintHeader ? complaintHeader : "Default",
              containerStyle: { maxWidth: "60%" },
              labelStyle: { letterSpacing: 0.7, wordWrap: "break-word", width: "100%" }
            }),
            _react2.default.createElement(
              "div",
              {
                style: role === "citizen" ? (0, _extends3.default)({
                  justifyContent: "center",
                  display: "flex",
                  borderRadius: 12,
                  width: "100px",
                  height: "30px",
                  alignItems: "center"
                }, getStatusAndChangeColor(complaint.status.status).containerStyle) : {}
              },
              _react2.default.createElement(_translationNode2.default, {
                className: "complaint-status-text text-bold",
                labelStyle: (0, _extends3.default)({
                  whiteSpace: "pre",
                  letterSpacing: 0.7,
                  wordBreak: "normal"

                }, getStatusAndChangeColor(complaint.status.status).style)
                // containerStyle={
                //   role === "citizen"
                //     ? {
                //         width: "20%",
                //         justifyContent: "center",
                //         display: "flex",
                //         ...getStatusAndChangeColor(complaint.status.status).containerStyle,
                //       }
                //     : {}
                // }
                , fontSize: role === "citizen" ? 12 : 14,
                label: "" + (complaint.complaintStatus && complaint.complaintStatus == "CLOSED" ? "Rating:" : "") + complaint.status.status,
                dynamicArray: [Math.abs(complaint.SLA)],
                bold: true
              })
            )
          ),
          _react2.default.createElement(
            "div",
            { className: "complaint-date-cont" },
            _react2.default.createElement(_components.Icon, { action: "action", name: "date-range" }),
            _react2.default.createElement(
              "span",
              { className: "complaint-date" },
              (0, _commons.getDateFromEpoch)(complaint.date)
            )
          ),
          _react2.default.createElement(
            "div",
            { className: "complaint-number-cont" },
            _react2.default.createElement(
              "div",
              { className: "complaint-number complaint-date" },
              _react2.default.createElement(_translationNode2.default, { fontSize: "12px", label: "CS_COMMON_COMPLAINT_NO" }),
              _react2.default.createElement(_translationNode2.default, { fontSize: "12px", label: " : " }),
              _react2.default.createElement(_translationNode2.default, { fontSize: "12px", label: complaint.complaintNo, className: "complaint-complaint-number" })
            )
          ),
          complaintLocation && complaint.addressDetail && !(0, _isEmpty2.default)(complaint.addressDetail) && _react2.default.createElement(
            "div",
            { className: "rainmaker-displayInline", style: { paddingBottom: "10px" } },
            _react2.default.createElement(_components.Icon, { className: "map-icon", action: "maps", name: "place", style: { marginRight: 10 }, color: "#767676" }),
            _react2.default.createElement(
              "div",
              { className: "complaint-address-display", style: { width: "60%" } },
              _react2.default.createElement(_translationNode2.default, {
                label: premise,
                className: "status-result-color",
                id: "complaint-details-complaint-location",
                labelStyle: { color: "inherit" },
                fontSize: "12px"
              }),
              premise && _react2.default.createElement(_translationNode2.default, {
                label: ", ",
                className: "comma-style",
                id: "complaint-details-complaint-location",
                labelStyle: { color: "inherit" },
                fontSize: "16px"
              }),
              _react2.default.createElement(_translationNode2.default, {
                label: streetName,
                className: "status-result-color",
                id: "complaint-details-complaint-location",
                labelStyle: { color: "inherit" },
                fontSize: "12px"
              }),
              streetName && _react2.default.createElement(_translationNode2.default, {
                label: ", ",
                className: "comma-style",
                id: "complaint-details-complaint-location",
                labelStyle: { color: "inherit" },
                fontSize: "16px"
              }),
              _react2.default.createElement(_translationNode2.default, {
                label: "ward-" + ward,
                className: "status-result-color",
                id: "complaint-details-complaint-location",
                labelStyle: { color: "inherit" },
                fontSize: "12px"
              }),
              ward && _react2.default.createElement(_translationNode2.default, {
                label: ", ",
                className: "comma-style",
                id: "complaint-details-complaint-location",
                labelStyle: { color: "inherit" },
                fontSize: "16px"
              }),
              _react2.default.createElement(_translationNode2.default, {
                label: pincode,
                className: "status-result-color",
                id: "complaint-details-complaint-location",
                labelStyle: { color: "inherit" },
                fontSize: "12px"
              })
            ),
            _react2.default.createElement(
              "div",
              { style: { width: "37%", textAlign: "right" } },
              _react2.default.createElement(
                "h3",
                { style: { fontSize: "13px", color: "rgb(21 12 164" } },
                complaint.servicetype == "1" ? "Nagar Bandhu" : complaint.servicetype == "0" && complaint.prevDept && "Transferred from  " + complaint.prevDept + " department"
              )
            )
          ),
          complaintLocation && complaint.address && (0, _isEmpty2.default)(complaint.addressDetail) && _react2.default.createElement(
            "div",
            { className: "complaint-address-cont" },
            _react2.default.createElement(_components.Icon, { className: "map-icon", action: "maps", name: "place", style: { marginRight: 10 }, color: "#767676" }),
            _react2.default.createElement(_translationNode2.default, { fontSize: "12px", color: "#484848", label: complaint.address, className: "complaint-address" })
          ),
          role === "citizen" && complaint && complaint.images && complaint.images.length > 0 && _react2.default.createElement(
            "div",
            { className: "complaint-image-cont" },
            complaint.images.map(function (image, index) {
              return image && _react2.default.createElement(
                "div",
                { className: "complaint-image-wrapper", key: index },
                _react2.default.createElement(_components.Image, { style: imageStyles, size: "medium", className: "complaint-image", width: "100%", height: 46, source: image }),
                " "
              );
            })
          ),
          role === "citizen" && _react2.default.createElement(_translationNode2.default, { labelStyle: { marginLeft: "3px" }, label: complaint.status.statusMessage, className: "complaint-status-text dark-color" }),
          bottomInfoTemplate(complaint, role)
        )
      })
    );
  });
};

exports.default = Complaints;


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/common/pgr/Complaints/index.js
// module id = 3384
// module chunks = 1137